<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <h4 class="d-flex align-items-center">
        <font-awesome-icon class="mr-50" icon="fa-solid fa-people-carry-box" />
        <span class="ml-1"
          >{{ newProductData.id > 0 ? "編輯" : "新增" }}商品</span
        >
      </h4>
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- Product id -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="編號："
                  label-for="id"
                  label-cols-md="3"
                  class="align-items-center"
                >
                  <div class="">
                    {{ newProductData.product_number?newProductData.product_number:'系統自動生成' }}
                  </div>
                </b-form-group>
              </b-col>

              <!-- product_status_id -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_product_status_id"
                >
                  <b-form-group
                    label="狀態："
                    label-for="product_status_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="product_status_id"
                      v-model="newProductData.product_status_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="productStatusOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.id"
                      placeholder="選擇商品狀態"
                      :filter="productStatusSearch"
                    >
                    </v-select>

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>


              <!-- type -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_product_category_id"
                >
                  <b-form-group
                    label="商品分類："
                    label-for="product_category_id"
                    label-cols-md="3"
                    class="required"
                  > 
                  <v-select
                      id="product_category_id"
                      v-model="newProductData.product_category_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="productCategoriesOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.id"
                      placeholder="選擇商品分類"
                      :filter="productCategorySearch"
                    >
                    </v-select>

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>              

              <!-- Product name -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_product_name"
                >
                  <b-form-group
                    label="商品名稱："
                    label-for="product_name"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="product_name"
                      v-model="newProductData.product_name"
                      placeholder="輸入商品名稱"
                      :state="getValidationState(validationContext)"
                      @blur="checkDuplicateProductName"
                    />
                
                    <label v-if="errorMessage && newProductData.product_name" class="text-danger">
                      {{ errorMessage }}
                    </label>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- brand -->
              <b-col cols="12" md="6">
                  <b-form-group
                    label="品牌："
                    label-for="brand"
                    label-cols-md="3"
                  >
                    <b-form-input
                      id="brand"
                      v-model="newProductData.brand"
                      placeholder="輸入品牌"
                    />
                  </b-form-group>
              </b-col>              

              <!-- size -->
              <!-- <b-col cols="12" md="6">
               
                  <b-form-group
                    label="尺寸："
                    label-for="size"
                    label-cols-md="3"
                  >
                    <b-form-input
                      id="size"
                      v-model="newProductData.size"
                      placeholder="輸入尺寸"
                    />
                  </b-form-group>
              </b-col> -->

              <b-col cols="12">
                <hr />
              </b-col>
              
              <!-- quantity -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_quantity"
                >
                  <b-form-group
                    label="數量："
                    label-for="quantity"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="quantity"
                      v-model="newProductData.quantity"
                      type="number"
                      step="any"
                      placeholder="輸入數量"
                      :state="getValidationState(validationContext)"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>              

              <!-- unit -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_product_unit_id"
                >
                  <b-form-group
                    label="單位："
                    label-for="unit"
                    label-cols-md="3"
                    class="required"
                  >
                  <v-select
                      id="product_unit_id"
                      v-model="newProductData.product_unit_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="productUnitOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.id"
                      placeholder="選擇商品單位"
                      :filter="productUnitSearch"
                    >
                    </v-select>
                    <!-- <b-form-input
                      id="unit"
                      v-model="newProductData.unit"
                      placeholder="輸入單位"
                      :state="getValidationState(validationContext)"
                    /> -->

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>
              
              <!-- price -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  :rules="newProductData.total_price > 0 || newProductData.unit_price > 0 ? '' : 'required'"
                  vid="v_unit_price"
                >
                  <b-form-group
                    label="單價："
                    label-for="unit_price"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="unit_price"
                      v-model="newProductData.unit_price"
                      placeholder="輸入全額或單價"
                      @input="newProductData.total_price = null"
                      :state="getValidationState(validationContext)"
                    />

                    <b-form-invalid-feedback v-if="!newProductData.total_price > 0 && !newProductData.unit_price > 0">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>              

              <!-- cost 還要嗎？-->
              <b-col cols="12" md="6" v-if="ability.can('admin', 'products') && false">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_cost"
                >
                  <b-form-group
                    label="成本："
                    label-for="cost"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="cost"
                      v-model="newProductData.cost"
                      placeholder="輸入成本"
                      :state="getValidationState(validationContext)"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  :rules="newProductData.total_price > 0 || newProductData.unit_price > 0 ? '' : 'required'"
                  vid="v_total_price"
                >
                  <b-form-group
                    label="全額："
                    label-for="total_price"
                    label-cols-md="3"
                    class="required"
                  >

                  <!-- @input="newProductData.unit_price = null" -->
                    <b-form-input
                      id="total_price"
                      v-model="total_price"
                      placeholder="輸入全額或單價"
                      :state="getValidationState(validationContext)"
                      disabled
                    />

                    <b-form-invalid-feedback v-if="!newProductData.total_price > 0 && !newProductData.unit_price > 0">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>       
              <b-col cols="12">
                <hr />
              </b-col>
       
              <!-- remark -->
              <b-col cols="12" md="12">
                <div
                  class="d-flex flex-wrap flex-md-nowrap align-items-center full_input"
                >
                  <label>備註/尺寸：</label>
                  <div class="input_wrap">
                   
                      <b-form-textarea
                        id="remark"
                        v-model="newProductData.remark"
                        placeholder="輸入備註/尺寸"
                        rows="3"
                      />
                  </div>
                </div>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

            </b-row>
          </div>

          <div class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-sm-2 mobile-w100"
              type="submit"
            >
              <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
              提交
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
              class="mt-1 mt-sm-0 mobile-w100"
            >
              取消
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BButton,
  BOverlay,
  BFormTextarea
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";
import ability from "@/libs/acl/ability";


export default {
  data() {
    return {
      required,
      ability,
      errorMessage: null,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BButton,
    BOverlay,
    BFormTextarea,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    total_price() {
      var amount = 
      Number(this.newProductData.unit_price) * Number(this.newProductData.quantity)
       ? Number(this.newProductData.unit_price) * Number(this.newProductData.quantity) : null;
      return Math.round(amount * 10) / 10;
    },
  },
  methods: {
    hide() {
      this.$router.replace("/products/list");
    },
    productStatusSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    productCategorySearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    productUnitSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    onSubmit() {
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("product/editProduct", this.newProductData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });

              this.hide();

            /*   if (this.newProductData.id == 0) {
                this.newProductData.id = response.data.id;
                this.redirect(response.data.id);
              } */
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    checkDuplicateProductName() {
      store.dispatch('product/checkDuplicateProductName', {
        id: this.newProductData.id ? this.newProductData.id : null, 
        product_name: this.newProductData.product_name
      }).then((response) => {
        this.errorMessage = null;
      })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorMessage = typeof error.response.data.message === 'string' ? error.response.data.message : null;
          }
        });
    },
      
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
  },
  props: {
    productData: {
      type: Object,
      required: true,
    },
    productStatusOptions: {
      type: Array,
      required: true,
    },
    productUnitOptions: {
      type: Array,
      required: true,
    },
    productCategoriesOptions: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const newProductData = ref({
      id: 0,
      total_price: null,
      unit_price: null,
      customer: {
        id: 0,
      },
    });

    watch(
      () => props.productData,
      (newVal) => {
        newProductData.value = { ...newVal };
      }
    );
    const resetWorkData = () => {
      newProductData.value = JSON.parse(
        JSON.stringify({
          id: 0,
          total_price: null,
          unit_price: null,
        })
      );
    };

    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetWorkData);

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newProductData,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
</style>
